"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const firestore_1 = require("@react-query-firebase/firestore");
const firestore_2 = require("firebase/firestore");
const keyFactory_1 = require("../keyFactory");
/**
 *
 * @returns Los dependants
 */
function usePillboxRecipe(firestore, recipeData, options, queryOptions) {
    const pillboxRef = (0, firestore_2.doc)(firestore, `user/${recipeData.uid}/pillbox`, recipeData.id);
    return (0, firestore_1.useFirestoreDocumentData)(keyFactory_1.FirestoreKeys.Pillbox({
        name: "Pillbox",
        path: `user/${recipeData.uid}/pillbox`
    }, [recipeData.uid, recipeData.id]), pillboxRef, options, queryOptions);
}
exports.default = usePillboxRecipe;
